import { env } from "../env/env";
import Storage from "../util/Storage";
import { Configuration } from "../generated/dashboard-client";

export const ops = (loginToken: string = "") => {
  if (!Storage.getToken() && !loginToken) return {};

  return {
    headers: {
      Authorization: "Bearer " + (loginToken || Storage.getToken()),
    },
  };
};

export const dashboardApiConfig = new Configuration({ basePath: env.apiPath });
export const accountApiConfig = new Configuration({ basePath: window.location.hostname.match("staging.mhmfun.com") ? "https://www.musthavemenus.com/account-stage" : env.accountContextPath });
export const printApiConfig = new Configuration({ basePath: env.printApiPath });
